module.exports = require('./multiply');
